"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUnitAd = exports.isProjectAd = exports.getAdTypeText = void 0;
var _constants = require("./constants");
var getAdTypeText = function getAdTypeText(adType, isLeisure) {
  switch (adType) {
    case _constants.AD_TYPE_KFS:
      return isLeisure ? 'Kommer for salg - fritid' : 'Kommer for salgs';
    case _constants.AD_TYPE_PTS:
      return 'Prosjekt til salg';
    case _constants.AD_TYPE_PTS_UNIT:
      return 'Prosjekt til salgs-enhet';
    case _constants.AD_TYPE_ETS:
      return 'Enkeltenhet til salg';
    case _constants.AD_TYPE_PTSF:
      return 'Prosjekt til salg - fritid';
    case _constants.AD_TYPE_PTSF_UNIT:
      return 'Prosjekt til salgs-enhet - fritid';
    default:
      return '';
  }
};
exports.getAdTypeText = getAdTypeText;
var isUnitAd = function isUnitAd(adType) {
  return adType === _constants.AD_TYPE_PTS_UNIT || adType === _constants.AD_TYPE_PTSF_UNIT;
};
exports.isUnitAd = isUnitAd;
var isProjectAd = function isProjectAd(adType) {
  return adType === _constants.AD_TYPE_PTS || adType === _constants.AD_TYPE_PTSF;
};
exports.isProjectAd = isProjectAd;